// Simple localStorage-backed favorites list.
const KEY = "sanctum_saved_songs";

export function getSaved() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}

export function isSaved(id) {
  return getSaved().includes(id);
}

export function toggleSaved(id) {
  const list = getSaved();
  const idx = list.indexOf(id);
  if (idx >= 0) list.splice(idx, 1);
  else list.unshift(id);
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("sanctum-saved-change"));
  return idx < 0; // true if now saved
}

export function useSavedCount() {
  const [n, setN] = require("react").useState(getSaved().length);
  require("react").useEffect(() => {
    const h = () => setN(getSaved().length);
    window.addEventListener("sanctum-saved-change", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("sanctum-saved-change", h);
      window.removeEventListener("storage", h);
    };
  }, []);
  return n;
}
